var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcesPageBannerW1440Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 1441,
    height: 300,
    fill: "url(#paint0_linear_10771_16459)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1364.3 222.034C1369.29 222.034 1369.29 214.283 1364.3 214.283C1359.31 214.283 1359.31 222.034 1364.3 222.034Z",
    fill: "#A3EA2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.88 160.876C1264.39 160.876 1264.39 157 1261.88 157C1259.37 157 1259.37 160.876 1261.88 160.876Z",
    fill: "#A3EA2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.57 257.509C1318.08 257.509 1318.08 253.633 1315.57 253.633C1313.06 253.633 1313.06 257.509 1315.57 257.509Z",
    fill: "#A3EA2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.74 209.751C336.727 209.751 336.727 202 331.74 202C326.753 202 326.753 209.751 331.74 209.751Z",
    fill: "#A3EA2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.68 89.7512C210.666 89.7512 210.666 81.9998 205.68 81.9998C200.693 81.9998 200.693 89.7512 205.68 89.7512Z",
    fill: "#A3EA2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.88 151.405C150.386 151.405 150.386 147.529 147.88 147.529C145.373 147.529 145.373 151.405 147.88 151.405Z",
    fill: "#A3EA2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220.355 256.1C222.862 256.1 222.862 252.224 220.355 252.224C217.849 252.224 217.849 256.1 220.355 256.1Z",
    fill: "#A3EA2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10771_16459",
    x1: 609.895,
    y1: -145.2,
    x2: 773.548,
    y2: 521.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#182337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#151C2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesPageBannerW1440Px);
export default __webpack_public_path__ + "static/media/resources-page-banner-w1440px.30f6e76778183b318686bc254f0ae51d.svg";
export { ForwardRef as ReactComponent };